import type { RouteObject } from 'react-router-dom';

import { orderMap } from '@/router/orderMap';

/**
 * 주문관리 라우터.
 *
 * ## 계층
 * - 샵 권한
 * - PC 레이아웃
 * - 샵 메인 레이아웃
 */
const orderRoutes: RouteObject[] = [
  {
    path: orderMap['integratedOrder'].path,
    async lazy() {
      const { default: Page } = await import('@/app/orders/pages/IntegratedOrderPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: orderMap['duplicatedOrder'].path,
    async lazy() {
      const { default: Page } = await import('@/app/orders/pages/DuplicatedOrderPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: orderMap['payment-pending'].path,
    async lazy() {
      const { default: Page } = await import('@/app/orders/pages/PaymentPendingPage');
      return {
        Component: Page,
      };
    },
  },

  {
    path: orderMap['payment-done'].path,
    async lazy() {
      const { default: Page } = await import('@/app/orders/pages/PaymentDonePage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: orderMap['discount-offer'].path,
    async lazy() {
      const { default: Page } = await import('@/app/orders/pages/DiscountOfferOrderPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: orderMap['shipping-pending'].path,
    async lazy() {
      const { default: Page } = await import('@/app/orders/pages/ShippingPendingPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: orderMap['shipping-in-progress'].path,
    async lazy() {
      const { default: Page } = await import('@/app/orders/pages/ShippingInProgressPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: orderMap['shipping-done'].path,
    async lazy() {
      const { default: Page } = await import('@/app/orders/pages/ShippingDonePage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: orderMap['purchase-done'].path,
    async lazy() {
      const { default: Page } = await import('@/app/orders/pages/PurchaseDonePage');
      return {
        Component: Page,
      };
    },
  },
];

export default orderRoutes;
